import React from "react";
import { observer } from "mobx-react";
import styles from "./InfoPopover.scss";
import informationIcon from "~assets/questionmark.svg";
import blackInformationIcon from "~assets/black-questionmark.svg";
import { useStores } from "netbank-shared/src/hooks";
import classNames from "classnames";

export interface IInfoPopoverProps {
  label?: string;
  popoverTitle?: string;
  className?: string;
  content?: string;
  color?: "default" | "black";
}

export const InfoPopover = observer(
  ({ label, popoverTitle, content, className, color = "default" }: IInfoPopoverProps) => {
    const { uiStore } = useStores();
    const popoverRef = React.useRef<HTMLDivElement>(null);
    const popoverIsOpen = uiStore.popover?.open;

    const handleOpenPopover = () => {
      if (!popoverRef.current) return;

      uiStore.setPopover({
        children: content,
        title: popoverTitle,
        open: true,
        element: popoverRef.current,
        xOffset: 5,
        yOffset: 10,
        cancelAction: () => {
          uiStore.removePopover();
        },
      });
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleOpenPopover();
      }
    };

    return (
      <div
        ref={popoverRef}
        role="button"
        tabIndex={0}
        className={classNames(styles.wrapper, className)}
        aria-haspopup="dialog"
        aria-expanded={popoverIsOpen ? "true" : "false"}
        aria-label={popoverTitle}
        onClick={handleOpenPopover}
        onKeyDown={handleKeyDown}
      >
        <img src={color === "default" ? informationIcon : blackInformationIcon} alt="" aria-hidden="true" />
        {label && <span>{label}</span>}
      </div>
    );
  }
);
